import RestUtilities from "lib/RestUtilities";
import { PublicationType, PublicationVisility } from "models/ApiEnums";
import {
    CommentItemInteractionDto,
    CommentListDto,
    CommentListItemDto,
    ContentMetadataGetDto, CourseContentDto,
    CourseEnrollReviewDto,
    CourseItemCompleteResult,
    CourseItemOperationResult,
    DeleteCommentResult, FeedItemActionRequesterDto, FeedItemDto,
    FeedRequestDto,
    FeedTopicDto,
    GenericListItemDto, GetAnswerDto, GetCommentListParams,
    GetCourseDto, GetFeedActionsParams, GetFeedAnswersParams,
    GetFeedCourseEnrollParams, GetFeedCourseListParams,
    GetFeedCourseParams, GetFeedFollowingParams, GetFeedHighlightsParams, GetFeedHistoryParams, GetFeedListParams,
    GetFeedMainParams, GetFeedPublicationParams,
    GetFeedQuestionsParams,
    GetFeedTopicParams,
    GetFeedUserProfileParams, GetListDto,
    GetPollDto, GetPostDto,
    GetQuestionDto, ListContentDto,
    NewCommentResult, PagedResult, PostCommentDto, PostFavoriteItemDto, PostLikeDto,
    PostNewFavoriteListDto,
    PostSeeLaterDto,
    PublicationActionGetDto,
    PublicationApprovalResultDto, PublicationLikeReviewDto, PublicationLookupFavoriteDto,
    PublicationRelationDto,
    PublicationRelationshipDto, PublicationShareDto,
    PublicationSocialActionResult, PublicationThanksReviewDto,
    PublicationUnblockDto,
    PublicationViewersDto, SaveAnswerDto,
    SaveCourseDto, SaveListDto,
    SavePollDto, SavePostDto,
    SavePublicationResult, SaveQuestionDto, SearchPublicationDto,
    SearchPublicationsExcludeOptions,
    SubtitleItemDto, TopicMembersOperationDto,
    TopicPredictionsDto, TopicRelationship,
    TopicStatisticsDto, TopicSuggestionDto,
    TopicWhoKnowsAboutDto, UserShortView,
    WordItemDto, WorkFlowStepDto
} from "models/ApiModels";
import moment from "moment";

//#region FEED

export function getFeedMain(params: GetFeedMainParams): Promise<FeedRequestDto> {
    return RestUtilities.post<FeedRequestDto>(`/api/v1.0/Knowledge/GetFeedMain`, params);
}

export function getFeedFollowing(params: GetFeedFollowingParams): Promise<FeedRequestDto> {
    return RestUtilities.post<FeedRequestDto>(`/api/v1.0/Knowledge/GetFeedFollowing`, params);
}

export function getFeedQuestions(params: GetFeedQuestionsParams): Promise<FeedRequestDto> {
    return RestUtilities.post<FeedRequestDto>(`/api/v1.0/Knowledge/GetFeedQuestions`, params);
}

export function getFeedHighlights(params: GetFeedHighlightsParams): Promise<FeedRequestDto> {
    return RestUtilities.post<FeedRequestDto>(`/api/v1.0/Knowledge/GetFeedHighlights`, params);
}

export function getFeedActions(params: GetFeedActionsParams): Promise<FeedRequestDto> {
    return RestUtilities.post<FeedRequestDto>("/api/v1.0/Knowledge/GetFeedActions", params);
}

export function getFeedList(params: GetFeedListParams): Promise<FeedRequestDto> {
    return RestUtilities.post<FeedRequestDto>("/api/v1.0/Knowledge/GetFeedList", params);
}

export function getFeedAnswers(params: GetFeedAnswersParams): Promise<FeedRequestDto> {
    return RestUtilities.post<FeedRequestDto>("/api/v1.0/Knowledge/GetFeedAnswers", params);
}

export function getFeedUserProfile(params: GetFeedUserProfileParams): Promise<FeedRequestDto> {
    return RestUtilities.post<FeedRequestDto>("/api/v1.0/Knowledge/GetFeedUserProfile", params);
}

export function getFeedPublications(params: GetFeedPublicationParams): Promise<FeedRequestDto> {
    return RestUtilities.post<FeedRequestDto>("/api/v1.0/Knowledge/GetFeedPublications", params);
}

export function getFeedHistory(params: GetFeedHistoryParams): Promise<FeedRequestDto> {
    return RestUtilities.post<FeedRequestDto>("/api/v1.0/Knowledge/GetFeedHistory", params);
}

export function getFeedItemPublication(publicationId: string, markRead: boolean, bodyExpanded: boolean = true): Promise<FeedItemDto> {
    return RestUtilities.get<FeedItemDto>("/api/v1.0/Knowledge/GetFeedItemPublication", { publicationId, markRead, bodyExpanded });
}

export function getFeedListItemPublication(listId: string, itemId: string, markRead: boolean): Promise<FeedItemDto> {
    return RestUtilities.post<FeedItemDto>("/api/v1.0/Knowledge/GetListItemPublication", { listId, itemId, markRead });
}


export function getPublicationFullContent(publicationId: string): Promise<string> {
    return RestUtilities.get<string>("/api/v1.0/Knowledge/GetPublicationFullContent", { publicationId });
}

export function getOthersAbuseReport(actionId: string): Promise<FeedItemActionRequesterDto[]> {
    return RestUtilities.get("/api/v1.0/Knowledge/GetOthersAbuseReport", { actionId });
}

export function postChangePublicationVisibility(publicationId: string, visibility: PublicationVisility): Promise<boolean> {
    return RestUtilities.post("/api/v1.0/Knowledge/ChangePublicationVisibility", { publicationId, visibility });
}


export function getFeedCourse(p: GetFeedCourseParams): Promise<FeedRequestDto> {
    return RestUtilities.post("/api/v1.0/Knowledge/GetFeedCourse", p);
}

export function getFeedItemOfCourse(courseId: string): Promise<FeedItemDto> {
    return RestUtilities.get<FeedItemDto>("/api/v1.0/Knowledge/GetFeedItemOfCourse", { courseId });
}


export function getFeedCourseItems(p: GetFeedCourseListParams): Promise<FeedRequestDto> {
    return RestUtilities.post("/api/v1.0/Knowledge/GetFeedCourseItems", p);
}

export function getFeedItemOfCourseItem(courseId: string, itemId: string): Promise<FeedItemDto> {
    return RestUtilities.get<FeedItemDto>("/api/v1.0/Knowledge/GetFeedItemOfCourseItem", { courseId, itemId });
}


export function getFeedEnrolledCourseItems(p: GetFeedCourseEnrollParams): Promise<FeedRequestDto> {
    return RestUtilities.post("/api/v1.0/Knowledge/GetFeedEnrolledCourseItems", p);
}

export function getFeedItemOfEnrolledCourseItem(courseId: string, itemId: string): Promise<FeedItemDto> {
    return RestUtilities.get<FeedItemDto>("/api/v1.0/Knowledge/GetFeedItemOfEnrolledCourseItem", { courseId, itemId });
}

//#endregion

//#region Topic

export function getTopicFeedHeader(topicId: string): Promise<FeedTopicDto> {
    return RestUtilities.post<FeedTopicDto>("/api/v1.0/Knowledge/GetTopicFeedHeader", { topicId });
}

export function getTopicFeedPublications(params: GetFeedTopicParams): Promise<FeedRequestDto> {
    return RestUtilities.post<FeedRequestDto>("/api/v1.0/Knowledge/GetFeedTopic", params);
}

export function getTopicPublication(topicId: string, publicationId: string): Promise<FeedItemDto> {
    return RestUtilities.get<FeedItemDto>("/api/v1.0/Knowledge/GetFeedItemFromTopicPublication", { topicId, publicationId });
}

export function getTopicRelations(topicId: string, take: number): Promise<TopicRelationship[]> {
    return RestUtilities.get<TopicRelationship[]>("/api/v1.0/Topic/GetRelations", { topicId, take });
}

export function shareTopic(dto: TopicMembersOperationDto): Promise<number> {
    return RestUtilities.post("/api/v1.0/Topic/Share", dto);
}

export function topicRequireKnowledgeTest(dto: TopicMembersOperationDto): Promise<boolean> {
    return RestUtilities.post<boolean>("/api/v1.0/Topic/RequireKnowledgeTest", dto);
}

export function getTopicFollowers(topicId: string, offset: number, take: number): Promise<PagedResult<UserShortView>> {
    return RestUtilities.get("/api/v1.0/Topic/GetFollowers", { topicId, offset, take });
}

export function getMembersFromTopicsWithRestriction(topics: string[], offset: number, take: number): Promise<PagedResult<GenericListItemDto>> {
    return RestUtilities.post<PagedResult<GenericListItemDto>>("/api/v1.0/Knowledge/GetMembersFromTopicsWithRestriction", { topics, offset, take });
}

export function getTopicWhoKnowsAbout(topicId: string, searchText: string, offset: number, take: number): Promise<PagedResult<TopicWhoKnowsAboutDto>> {
    return RestUtilities.get("/api/v1.0/Topic/GetWhoKnowsAbout", { topicId, searchText, offset, take });
}

export function getTopicStatistics(topicId: string): Promise<TopicStatisticsDto> {
    return RestUtilities.get("/api/v1.0/Topic/GetStatistics", { topicId });
}

//#endregion

//#region POST PUBLICATION

export function getPost(publicationId: string): Promise<GetPostDto> {
    return RestUtilities.post<GetPostDto>("/api/v1.0/Knowledge/GetPost", { publicationId });
}

export function savePost(dto: SavePostDto): Promise<SavePublicationResult> {
    return RestUtilities.post("/api/v1.0/Knowledge/SavePost", dto);
}

export function deletePost(publicationId: string): Promise<boolean> {
    return RestUtilities.post<boolean>("/api/v1.0/Knowledge/DeletePost", { publicationId });
}

//#endregion

//#region POOL PUBLICATION

export function getPoll(publicationId: string): Promise<GetPollDto> {
    return RestUtilities.get("/api/v1.0/Knowledge/GetPoll", { publicationId });
}

export function savePoll(dto: SavePollDto): Promise<SavePublicationResult> {
    return RestUtilities.post("/api/v1.0/Knowledge/SavePoll", dto);
}

export function postAnswer(publicationId: string, answerId: string): Promise<FeedItemDto> {
    return RestUtilities.post("/api/v1.0/Knowledge/PostPollAnswer", { publicationId, answerId });
}

export function deletePoll(publicationId: string): Promise<boolean> {
    return RestUtilities.post<boolean>("/api/v1.0/Knowledge/DeletePoll", { publicationId });
}

//#endregion

//#region QUESTION PUBLICATION

export function getQuestion(publicationId: string): Promise<GetQuestionDto> {
    return RestUtilities.post<GetQuestionDto>("/api/v1.0/Knowledge/GetQuestion", { publicationId });
}

export function saveQuestion(dto: SaveQuestionDto): Promise<SavePublicationResult> {
    return RestUtilities.post("/api/v1.0/Knowledge/SaveQuestion", dto);
}

export function deleteQuestion(publicationId: string): Promise<boolean> {
    return RestUtilities.post<boolean>("/api/v1.0/Knowledge/DeleteQuestion", { publicationId });
}

export function searchQuestionSuggestions(userId: string, searchText: string, excludeQuestions: string[], offset: number, take: number): Promise<SearchPublicationDto[]> {
    return RestUtilities.post<SearchPublicationDto[]>("/api/v1.0/Knowledge/SearchQuestions", { userId, searchText, excludeQuestions, offset, take }, true);
}

export function hasSearchTextInAnswers(userId: string, questionId: string, searchText: string): Promise<boolean> {
    return RestUtilities.post("/api/v1.0/Knowledge/HasSearchTextInAnswers", { userId, questionId, searchText }, true);
}

//#endregion

//#region QUESTION ANSWER PUBLICATION

export function getAnswer(publicationId: string): Promise<GetAnswerDto> {
    return RestUtilities.post<GetAnswerDto>("/api/v1.0/Knowledge/GetAnswer", { publicationId });
}

export function saveAnswer(dto: SaveAnswerDto): Promise<SavePublicationResult> {
    return RestUtilities.post<SavePublicationResult>("/api/v1.0/Knowledge/SaveAnswer", dto);
}

export function deleteAnswer(publicationId: string): Promise<boolean> {
    return RestUtilities.post<boolean>("/api/v1.0/Knowledge/DeleteAnswer", { publicationId });
}

//#endregion

//#region LIST PUBLICATION

export function getListContent(listId: string): Promise<ListContentDto[]> {
    return RestUtilities.post<ListContentDto[]>("/api/v1.0/Knowledge/GetListContent", { listId });
}

export function getList(listId: string): Promise<GetListDto> {
    return RestUtilities.post<GetListDto>("/api/v1.0/Knowledge/GetList", { listId });
}

export function saveList(dto: SaveListDto): Promise<SavePublicationResult> {
    return RestUtilities.post("/api/v1.0/Knowledge/SaveList", dto);
}

export function listClear(listId: string): Promise<boolean> {
    return RestUtilities.post<boolean>("/api/v1.0/Knowledge/ClearList", { listId });
}

export function listReorder(listId: string, publications: string[]): Promise<boolean> {
    return RestUtilities.post<boolean>("/api/v1.0/Knowledge/ReorderList", { listId, publications });
}

export function listAddPublication(listId: string, publicationId: string, suggestionComment: string): Promise<boolean> {
    return RestUtilities.post<boolean>("/api/v1.0/Knowledge/ListAddPublication", { listId, publicationId, suggestionComment });
}

export function listRemovePublication(listId: string, publicationId: string): Promise<boolean> {
    return RestUtilities.post<boolean>("/api/v1.0/Knowledge/ListRemovePublication", { listId, publicationId });
}

export function listAuthorsSelection(listId: string, searchText: string, offset: number, take: number): Promise<PagedResult<GenericListItemDto>> {
    return RestUtilities.get<PagedResult<GenericListItemDto>>("/api/v1.0/Knowledge/ListAuthorsSelection", { listId, searchText, offset, take });
}


//#endregion

//#region COURSE PUBLICATION

export function getCourse(courseId: string): Promise<GetCourseDto> {
    return RestUtilities.post("/api/v1.0/Knowledge/GetCourse", { courseId });
}

export function getCourseContent(courseId: string): Promise<CourseContentDto[]> {
    return RestUtilities.post<CourseContentDto[]>("/api/v1.0/Knowledge/GetCourseContent", { courseId });
}

export function saveCourse(dto: SaveCourseDto): Promise<SavePublicationResult> {
    return RestUtilities.post("/api/v1.0/Knowledge/SaveCourse", dto);
}

export function courseReorder(courseId: string, publications: string[]): Promise<boolean> {
    return RestUtilities.post<boolean>("/api/v1.0/Knowledge/ReorderCourse", { courseId, publications });
}

export function courseAddPublication(courseId: string, publicationId: string): Promise<CourseItemOperationResult> {
    return RestUtilities.post("/api/v1.0/Knowledge/CourseAddPublication", { courseId, publicationId });
}

export function courseRemovePublication(courseId: string, publicationId: string): Promise<CourseItemOperationResult> {
    return RestUtilities.post("/api/v1.0/Knowledge/CourseRemovePublication", { courseId, publicationId });
}

export function coursePublish(courseId: string): Promise<boolean> {
    return RestUtilities.post<boolean>("/api/v1.0/Knowledge/CoursePublish", { courseId });
}

export function courseRollback(courseId: string): Promise<boolean> {
    return RestUtilities.post<boolean>("/api/v1.0/Knowledge/CourseRollback", { courseId });
}

export function courseEnroll(courseId: string, userId: string): Promise<boolean> {
    return RestUtilities.post<boolean>("/api/v1.0/Knowledge/CourseEnroll", { courseId, userId });
}

export function courseBatchEnroll(courseId: string, members: string[]): Promise<number> {
    return RestUtilities.post<number>("/api/v1.0/Knowledge/CourseBatchEnroll", { courseId, members });
}

export function courseCancelEnroll(courseId: string, userId: string): Promise<boolean> {
    return RestUtilities.post<boolean>("/api/v1.0/Knowledge/CourseCancelEnroll", { courseId, userId });
}

export function courseEnrollItemComplete(courseId: string, itemId: string): Promise<CourseItemCompleteResult> {
    return RestUtilities.post("/api/v1.0/Knowledge/CourseEnrollItemComplete", { courseId, itemId });
}

export function courseEnrollPlaytime(courseId: string, itemId: string, playtime: number): Promise<boolean> {
    return RestUtilities.post<boolean>("/api/v1.0/Knowledge/CourseEnrollRegisterPlaytime", { courseId, itemId, playtime });
}

export function getCourseEnrollReviewList(courseId: string, username: string, offset: number, take: number): Promise<PagedResult<CourseEnrollReviewDto>> {
    return RestUtilities.post("/api/v1.0/Knowledge/GetCourseEnrollReviewList", { courseId, username, range: { offset, take } });
}

export function getCourseWhoCanEnroll(courseId: string, username: string, offset: number, take: number): Promise<PagedResult<UserShortView>> {
    return RestUtilities.post("/api/v1.0/Knowledge/GetCourseWhoCanEnroll", { courseId, username, range: { offset, take } });
}

export function courseAuthorsSelection(searchText: string, offset: number, take: number): Promise<PagedResult<GenericListItemDto>> {
    return RestUtilities.get<PagedResult<GenericListItemDto>>("/api/v1.0/Knowledge/CourseAuthorsSelection", { searchText, offset, take });
}

//#endregion

//#region PUBLICATION COMMON ACTIONS

export function getWorkflowSteps(publicationId: string): Promise<WorkFlowStepDto[]> {
    return RestUtilities.get("/api/v1.0/Knowledge/GetPublicationWorkflowSteps", { publicationId });
}

export function postSuggestionApproval(actionId: string, approved: boolean, notes: string): Promise<boolean> {
    return RestUtilities.post<boolean>("/api/v1.0/Knowledge/ExecuteSuggestionApproval", { actionId, approved, notes });
}

export function ignoreActionRequest(actionId: string): Promise<PublicationApprovalResultDto> {
    return RestUtilities.post("/api/v1.0/Knowledge/IgnoreActionRequested", { actionId });
}

export function approvalActionRequest(actionId: string, approved: boolean, notes: string): Promise<PublicationApprovalResultDto> {
    return RestUtilities.post("/api/v1.0/Knowledge/ApprovalActionRequested", { actionId, approved, notes });
}


export function getMetadataFromUrl(url: string): Promise<ContentMetadataGetDto> {
    return RestUtilities.get("/api/v1.0/UrlParser/GetMeta", { url: url });
}


export function searchPublications(userId: string, searchText: string, offset: number, take: number, options: SearchPublicationsExcludeOptions): Promise<SearchPublicationDto[]> {
    return RestUtilities.post<SearchPublicationDto[]>("/api/v1.0/Knowledge/SearchPublications", { userId, searchText, offset, take, options });
}

export function addManualPublicationRelationship(publicationId: string, relatedPublicationId: string): Promise<PublicationRelationshipDto> {
    return RestUtilities.post("/api/v1.0/Knowledge/AddManualPublicationRelationship", { publicationId, relatedPublicationId });
}

export function deleteManualPublicationRelationship(publicationId: string, relatedPublicationId: string): Promise<boolean> {
    return RestUtilities.delete("/api/v1.0/Knowledge/DeleteManualPublicationRelationship", { publicationId, relatedPublicationId });
}

export function getPublicationRelationships(publicationId: string): Promise<PublicationRelationshipDto[]> {
    return RestUtilities.get("/api/v1.0/Knowledge/GetPublicationRelationships", { publicationId });
}

export function getPublicationRelations(publicationId: string): Promise<PublicationRelationDto[]> {
    return RestUtilities.get<PublicationRelationDto[]>("/api/v1.0/Knowledge/GetPublicationRelations", { publicationId });
}

export function getPublicationRecommendationsToUser(publicationId: string, userId: string): Promise<PublicationRelationDto[]> {
    return RestUtilities.get<PublicationRelationDto[]>("/api/v1.0/Knowledge/GetRecommendationsToUser", { publicationId, userId });
}


export function canWriteAbuseReport(publicationId: string): Promise<PublicationActionGetDto> {
    return RestUtilities.get("/api/v1.0/Knowledge/CanWriteAbuseReport", { publicationId });
}
export function getPublicationAbuseReportAction(publicationId: string): Promise<PublicationActionGetDto> {
    return RestUtilities.get("/api/v1.0/Knowledge/GetPublicationAbuseReportAction", { publicationId });
}
export function postPublicationAbuseReport(publicationId: string, message: string): Promise<FeedItemDto> {
    return RestUtilities.post<FeedItemDto>("/api/v1.0/Knowledge/PostPublicationAbuseReport", { publicationId, message });
}
export function updatePublicationAbuseReport(actionId: string, message: string): Promise<FeedItemDto> {
    return RestUtilities.post<FeedItemDto>("/api/v1.0/Knowledge/UpdatePublicationAbuseReport", { actionId, message });
}
export function deletePublicationAbuseReport(actionId: string): Promise<FeedItemDto> {
    return RestUtilities.delete("/api/v1.0/Knowledge/DeletePublicationAbuseReport", { actionId });
}


export function canUnblockPublication(publicationId: string): Promise<PublicationUnblockDto> {
    return RestUtilities.get("/api/v1.0/Knowledge/CanUnblockPublication", { publicationId });
}
export function getPublicationUnblockAction(publicationId: string): Promise<PublicationActionGetDto> {
    return RestUtilities.get("/api/v1.0/Knowledge/GetPublicationUnblockAction", { publicationId });
}
export function postRequestUnblockPublication(publicationId: string, message: string): Promise<FeedItemDto> {
    return RestUtilities.post<FeedItemDto>("/api/v1.0/Knowledge/RequestUnblockPublication", { publicationId, message });
}
export function updateRequestUnblockPublication(actionId: string, message: string): Promise<FeedItemDto> {
    return RestUtilities.post<FeedItemDto>("/api/v1.0/Knowledge/UpdateRequestUnblockPublication", { actionId, message });
}

export function requestQuestionAnswer(publicationId: string, toUserId: string, comment: string): Promise<boolean> {
    return RestUtilities.post<boolean>("/api/v1.0/Knowledge/RequestQuestionAnswer", { publicationId, toUserId, comment });
}
export function deleteRequestUnblockPublication(actionId: string): Promise<FeedItemDto> {
    return RestUtilities.delete("/api/v1.0/Knowledge/DeleteRequestUnblockPublication", { actionId });
}

export function followPublication(publicationId: string): Promise<boolean> {
    return RestUtilities.post<boolean>("/api/v1.0/Knowledge/FollowPublication", { publicationId });
}

export function unfollowPublication(publicationId: string): Promise<boolean> {
    return RestUtilities.post<boolean>("/api/v1.0/Knowledge/UnfollowPublication", { publicationId });
}


export function addHighlightPublication(publicationId: string, days: number): Promise<Date> {
    return RestUtilities.post("/api/v1.0/Knowledge/HighlightPublication", {
        publicationId,
        highlightUntil: moment().add(days, 'days').endOf('day').toDate()
    });
}

export function cancelHighlightPublication(publicationId: string): Promise<boolean> {
    return RestUtilities.post("/api/v1.0/Knowledge/CancelHighlightPublication", { publicationId });
}


export function updatePublicationTopics(publicationId: string, topics: string[]): Promise<TopicSuggestionDto[]> {
    return RestUtilities.post<TopicSuggestionDto[]>("/api/v1.0/Knowledge/UpdatePublicationTopics", { publicationId, topics });
}

export function deleteTopicFromPublication(publicationId: string, topicId: string): Promise<TopicSuggestionDto[]> {
    return RestUtilities.post<TopicSuggestionDto[]>("/api/v1.0/Knowledge/DeleteTopicFromPublication", { publicationId, topicId });
}


export function deletePublication(publicationId: string, publicationType: PublicationType): Promise<boolean> {
    let service = "";
    switch (publicationType) {
        case PublicationType.Answer: service = "DeleteAnswer"; break;
        case PublicationType.List: service = "DeleteList"; break;
        case PublicationType.Poll: service = "DeletePoll"; break;
        case PublicationType.Post: service = "DeletePost"; break;
        case PublicationType.Question: service = "DeleteQuestion"; break;
        case PublicationType.Survey: service = "DeleteSurvey"; break;
        case PublicationType.Course: service = "DeleteCourse"; break;
        default: throw new Error("Cannot find a Delete Service for type '" + PublicationType[publicationType] + "'.");
    }
    return RestUtilities.post<boolean>(`/api/v1.0/Knowledge/${service}`, { publicationId });
}

export function publishDraftPublication(publicationId: string, publicationType: PublicationType): Promise<boolean> {
    let service = "";
    switch (publicationType) {
        case PublicationType.Post: service = "PublishPost"; break;
        case PublicationType.Answer: service = "PublishAnswer"; break;
        default: throw new Error("Cannot find a Publish Service for type '" + PublicationType[publicationType] + "'.");
    }
    return RestUtilities.post<boolean>(`/api/v1.0/Knowledge/${service}`, { publicationId });
}

export function publicationSwapBlock(publicationId: string, message: string): Promise<boolean> {
    return RestUtilities.post<boolean>("/api/v1.0/Knowledge/SwapBlockPublication", { publicationId, message });
}

export function getFileSubtitle(fileId: string): Promise<string> {
    return RestUtilities.get("/api/v1.0/Knowledge/GetFileSubtitle", { fileId });
}

export function getMetadataSubtitle(publicationId: string): Promise<string> {
    return RestUtilities.get("/api/v1.0/Knowledge/GetMetadataSubtitle", { publicationId });
}

export function getTopicPrediction(title: string, body: string): Promise<TopicSuggestionDto> {
    return RestUtilities.post("/api/v1.0/Knowledge/GetTopicPrediction", { title, body });
}

export function getTopicPredictions(title: string, body: string): Promise<TopicPredictionsDto> {
    return RestUtilities.post("/api/v1.0/Knowledge/GetTopicPredictions", { title, body });
}

export function getHierarchyTopicSuggestions(primaryTopics: string[], deletedRelativeTopics: string[]): Promise<TopicSuggestionDto[]> {
    return RestUtilities.post("/api/v1.0/Knowledge/GetHierarchyTopicSuggestions", { primaryTopics, deletedRelativeTopics });
}

//#endregion


//#region Subtitles

export function matchQuerySearchWithFileSubtitles(fileId: string, querySearch: string): Promise<WordItemDto[]> {
    return RestUtilities.get("/api/v1.0/Knowledge/MatchQuerySearchWithFileSubtitles", { fileId, querySearch });
}

export function matchQuerySearchWithMetadataSubtitles(publicationId: string, querySearch: string): Promise<WordItemDto[]> {
    return RestUtilities.get("/api/v1.0/Knowledge/MatchQuerySearchWithMetadataSubtitles", { publicationId, querySearch });
}


export function searchFileSubtitles(fileId: string, search: string): Promise<SubtitleItemDto[]> {
    return RestUtilities.get("/api/v1.0/Knowledge/SearchFileSubtitles", { fileId, search });
}

export function searchMetadataSubtitles(publicationId: string, search: string): Promise<SubtitleItemDto[]> {
    return RestUtilities.get("/api/v1.0/Knowledge/SearchMetadataSubtitles", { publicationId, search });
}

//#endregion


//#region PUBLICATION SOCIAL

export function getUserFavoriteList(): Promise<PublicationLookupFavoriteDto[]> {
    return RestUtilities.post<PublicationLookupFavoriteDto[]>("/api/v1.0/Knowledge/GetUserFavoriteList", {});
}

export function getFavorites(verifyItemId: string, searchText?: string): Promise<PublicationLookupFavoriteDto[]> {
    return RestUtilities.post<PublicationLookupFavoriteDto[]>("/api/v1.0/Knowledge/GetFavorites", { verifyItemId, searchText });
}

export function postFavorite(dto: PostFavoriteItemDto): Promise<PublicationLookupFavoriteDto[]> {
    return RestUtilities.post<PublicationLookupFavoriteDto[]>("/api/v1.0/Knowledge/PostFavorite", dto);
}

export function postNewFavoriteList(dto: PostNewFavoriteListDto): Promise<PublicationLookupFavoriteDto[]> {
    return RestUtilities.post<PublicationLookupFavoriteDto[]>("/api/v1.0/Knowledge/postNewFavoriteList", dto);
}

export function postSeeLater(dto: PostSeeLaterDto): Promise<boolean> {
    return RestUtilities.post<boolean>("/api/v1.0/Knowledge/PostSeeLater", dto);
}

export function postLike(dto: PostLikeDto): Promise<PublicationSocialActionResult> {
    return RestUtilities.post("/api/v1.0/Knowledge/PostLike", dto);
}

export function addThanks(publicationId: string, message: string): Promise<PublicationSocialActionResult> {
    return RestUtilities.post<PublicationSocialActionResult>("/api/v1.0/Knowledge/AddThanks", { publicationId, message });
}

export function removeThanks(publicationId: string): Promise<PublicationSocialActionResult> {
    return RestUtilities.post("/api/v1.0/Knowledge/RemoveThanks", { publicationId });
}

export function postShare(dto: PublicationShareDto): Promise<boolean> {
    return RestUtilities.post("/api/v1.0/Knowledge/PostShare", dto);
}

export function getLikeReviewList(publicationId: string, startDate: Date, endDate: Date, offset: number, take: number): Promise<PublicationLikeReviewDto> {
    return RestUtilities.post("/api/v1.0/Knowledge/GetPublicationLikesReviewList", { publicationId, startDate, endDate, range: { offset, take } });
}

export function getThanksReviewList(publicationId: string, startDate: Date, endDate: Date, offset: number, take: number): Promise<PublicationThanksReviewDto> {
    return RestUtilities.post("/api/v1.0/Knowledge/GetPublicationThanksReviewList", { publicationId, startDate, endDate, range: { offset, take } });
}

export function getViewersList(publicationId: string, startDate: Date, endDate: Date, offset: number, take: number): Promise<PublicationViewersDto> {
    return RestUtilities.post("/api/v1.0/Knowledge/GetPublicationViewersList", { publicationId, startDate, endDate, range: { offset, take } });
}

//#endregion

//#region PUBLICATION COMMENTS

export function getComments(p: GetCommentListParams): Promise<CommentListDto> {
    return RestUtilities.post("/api/v1.0/Knowledge/GetComments", p);
}

export function postComment(dto: PostCommentDto): Promise<NewCommentResult> {
    return RestUtilities.post("/api/v1.0/Knowledge/PostComment", dto);
}

export function updateComment(commentId: string, message: string): Promise<CommentListItemDto> {
    return RestUtilities.post("/api/v1.0/Knowledge/UpdateComment", { commentId, message });
}

export function postCommentLike(dto: PostLikeDto): Promise<CommentItemInteractionDto> {
    return RestUtilities.post("/api/v1.0/Knowledge/PostCommentLike", dto);
}

export function deleteComment(commentId: string): Promise<DeleteCommentResult> {
    return RestUtilities.post("/api/v1.0/Knowledge/RemoveComment", { commentId });
}


export function getCommentAbuseReportAction(commentId: string): Promise<PublicationActionGetDto> {
    return RestUtilities.get("/api/v1.0/Knowledge/GetCommentAbuseReportAction", { commentId });
}

export function postCommentAbuseReport(commentId: string, message: string): Promise<CommentItemInteractionDto> {
    return RestUtilities.post("/api/v1.0/Knowledge/PostCommentAbuseReport", { commentId, message });
}

export function updateCommentAbuseReport(actionId: string, message: string): Promise<CommentItemInteractionDto> {
    return RestUtilities.post("/api/v1.0/Knowledge/UpdateCommentAbuseReport", { actionId, message });
}

export function deleteCommentAbuseReport(actionId: string): Promise<CommentItemInteractionDto> {
    return RestUtilities.delete("/api/v1.0/Knowledge/DeleteCommentAbuseReport", { actionId });
}

//#endregion
